import Vue from 'vue' //vue.js 모든 파일에 쓸수 있게 적용
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import '@coreui/coreui'
import '@coreui/coreui/dist/css/coreui.css'
import '@coreui/icons'
import '@coreui/icons/css/all.css'
// import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
// import 'bootstrap-datepicker/css/datepicker.css';




Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
